import { useQuery } from '@tanstack/react-query';
import { configApi } from '../../configApi';

export interface ISelectiveProcessVancancy {
  id: string;
  name: string;
  has_pcd: boolean;
  has_black_or_brown: boolean;
  number_of_extensive_competition_vacancies: number;
  number_of_paa_vacancies: number;
  number_of_ufc_server_vacancies: number;
  type_of_competition: ISelectObject[];
  level: ISelectObject;
  research_line?: ISelectObject | string | null;
  thematic_axis?: ISelectObject | string | null;
}

export interface ISelectObject {
  id: string;
  name: string;
}

interface IVacancyFilters {
  level_id?: string;
  research_line_id?: string;
  thematic_axis_id?: string;
}

const RequestSelectiveProcessVacancy = async (
  selective_process_id: string,
  is_cultural_house: boolean,
  cultural_house_id: string = '',
  type_of_vacancy: string = '',
  filters?: IVacancyFilters,
) => {
  if (is_cultural_house && (!selective_process_id || !cultural_house_id)) return [];
  const response = await configApi.get<ISelectiveProcessVancancy[]>(`candidate-area/vacancies/`, {
    params: {
      selective_process_id: selective_process_id,
      cultural_house_id: cultural_house_id || undefined,
      is_initial_semester: type_of_vacancy === 'is_initial_semester' ? true : undefined,
      is_level_test: type_of_vacancy === 'is_level_test' ? true : undefined,
      remove_pagination: true,
      ...filters,
    },
  });
  return response.data;
};

export const useRequestSelectiveProcessVacancy = (
  selective_process_id: string,
  is_cultural_house: boolean,
  cultural_house_id?: string,
  type_of_vacancy?: string,
  filters?: IVacancyFilters,
) => {
  return useQuery({
    queryKey: ['selective_process_vacancy', selective_process_id, cultural_house_id, type_of_vacancy, filters],
    queryFn: () =>
      RequestSelectiveProcessVacancy(
        selective_process_id,
        is_cultural_house,
        cultural_house_id,
        type_of_vacancy,
        filters,
      ),
    refetchOnWindowFocus: false,
  });
};
